
import React from "react";
import AuthLayout from "../layouts/AuthLayout";
import { RouterKeys } from "./RouterKeys";
import ProtectRoute from "./ProtectRoute";
import AuthProtect from "./AuthProtect";
import MainLayout from "../layouts/MainLayout";

// Route-level code splitting: screen components are only fetched when their
// route is actually visited, keeping the Login screen's initial bundle free
// of Highcharts/Jodit/etc. App.js already wraps the router in a Suspense
// boundary (fallback: SuspenseLoader), so no extra Suspense is needed here.
const ForgotPassword = React.lazy(() => import("../screen/Auth/ForgotPassword"));
const Login = React.lazy(() => import("../screen/Auth/Login"));
const OTPVerify = React.lazy(() => import("../screen/Auth/OTPVerify"));
const NewPassword = React.lazy(() => import("../screen/Auth/NewPassword"));
const Home = React.lazy(() => import("../screen/NonAuth/Home/Home"));
const Users = React.lazy(() => import("../screen/NonAuth/Users/Users"));
const Category = React.lazy(() => import("../screen/NonAuth/Category/Category"));
const UserDetailView = React.lazy(() => import("../screen/NonAuth/Users/UserDetailView"));
const CategoryView = React.lazy(() => import("../screen/NonAuth/Category/CategoryView"));
const Community = React.lazy(() => import("../screen/NonAuth/Community/Community"));
const CommunityDetail = React.lazy(() => import("../screen/NonAuth/Community/CommunityDetail"));
const FAQList = React.lazy(() => import("../screen/NonAuth/FAQ/FAQList"));
const Terms = React.lazy(() => import("../screen/NonAuth/General/Terms"));
const Privacy = React.lazy(() => import("../screen/NonAuth/General/Privacy"));
const ReportUser = React.lazy(() => import("../screen/NonAuth/Reports/ReportUser"));
const Post = React.lazy(() => import("../screen/NonAuth/Reports/Post"));
const Comments = React.lazy(() => import("../screen/NonAuth/Reports/Comments"));
const PostDetail = React.lazy(() => import("../screen/NonAuth/Reports/PostDetail"));
const CommentDetail = React.lazy(() => import("../screen/NonAuth/Reports/CommentDetail"));
const ChangePassword = React.lazy(() => import("../screen/NonAuth/General/ChangePassword"));
// import UploadStatus from "../screen/Auth/Home/UploadStatus";

export const AppRouter = [
    // Auth Part
    {
        path: RouterKeys.NON_Auth.CONTINUE,
        element: (
            <AuthProtect>
                <AuthLayout />,
            </AuthProtect>
        ),
        children: [
            {
                index: true,  // Default route when visiting '/'
                element: <Login />,
            },
            {
                path: RouterKeys.AUTH.FORGOT_PASSWORD,
                element: <ForgotPassword />,
            },
            {
                path: RouterKeys.AUTH.OTP_VERIFY,
                element: <OTPVerify />,
            },
            {
                path: RouterKeys.AUTH.CREATE_PASSWORD,
                element: <NewPassword />,
            },
        ],
    },
    // after login parts
    {
        element: (
            <ProtectRoute>
                <MainLayout />
            </ProtectRoute>
        ),
        children: [
            {
                path: RouterKeys.NON_Auth.HOME,
                element: <Home />,
            },
            {
                path: RouterKeys.NON_Auth.USERS,
                element: <Users />,
            },
            {
                path: RouterKeys.NON_Auth.USER_Detail,
                element: <UserDetailView />,
            },
            {
                path: RouterKeys.NON_Auth.CATEGORY,
                element: <Category />,
            },
            {
                path: RouterKeys.NON_Auth.CATEGORY_DETAIL,
                element: <CategoryView />,
            },
            {
                path: RouterKeys.NON_Auth.COMMUNITY,
                element: <Community />,
            },
            {
                path: RouterKeys.NON_Auth.COMMUNITY_DETAIL,
                element: <CommunityDetail />,
            },
            {
                path: RouterKeys.NON_Auth.FAQ,
                element: <FAQList />,
            },
            {
                path: RouterKeys.NON_Auth.REPORT_USERS,
                element: <ReportUser />,
            },
            {
                path: RouterKeys.NON_Auth.REPORT_POST,
                element: <Post />,
            },
            {
                path: RouterKeys.NON_Auth.REPORT_POST_DETAIL,
                element: <PostDetail />,
            },
            {
                path: RouterKeys.NON_Auth.REPORT_COMMENTS,
                element: <Comments />,
            },
            {
                path: RouterKeys.NON_Auth.REPORT_COMMENTS_DETAIL,
                element: <CommentDetail />,
            },
            {
                path: RouterKeys.NON_Auth.TERMS_CONDITION,
                element: <Terms />,
            },
            {
                path: RouterKeys.NON_Auth.PRIVACY,
                element: <Privacy />,
            },
            {
                path: RouterKeys.NON_Auth.CHANGE_PASSWORD,
                element: <ChangePassword/>,
            },
        ],
    },
];

